import React from "react";
import "../../styles/herovideo.css";

const HeroVideo = () => {
  return (
    <div className="hero-video-container">
      <video
        autoPlay
        loop
        muted
        playsInline
        className="hero-video"
      >
        <source src="/videos/header.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>
    </div>
  );
};

export default HeroVideo;
